import { SET_SELECTED_COMMESSA } from '../actions/selectedCommessa';

export const selectedCommessa = (state = {}, action) => {
  switch (action.type) {
    case SET_SELECTED_COMMESSA: {
      return { ...action.payload }
    }
    default: return state;
  }
}